<template>
    <HeroSection :featureName="baseFeature.name" :icon="baseFeature.icon">
        <template #title>{{ baseFeature.description }}</template>
        <template #description>          
            
            
            <p class="mt-4">Add tickets, discount codes and complex conditional logic to your registration forms. Fully customisable branding and messaging.</p>
            <p class="mt-4">Profiles are created instantly, providing immediate access to the full platform, including app access, badging and lead capture.</p>

        </template>
        <template #content>
            <CmsAndApp :webImage="webImage" :appImage="appImage" />
        </template>
    </HeroSection>

    <CmsLarge title="Registration Builder" copy="Set up your messaging and override project branding if required. Add elements from profile fields, tickets and session selection." :imageSrc="builder" />

    <Tips :title="baseFeature.name" :tips="tips" />
    <WorksWith :title="baseFeature.name" :integrations="integrations" />
    <Cta />
</template>

<script setup>
import Cta from '../../components/Blocks/Cta.vue';
import HeroSection from '../../components/HeroSection.vue';
import CmsAndApp from '../../components/Layouts/CmsAndApp.vue';
import Tips from '../../components/Blocks/Tips.vue';

import WorksWith from '../../components/Blocks/WorksWith.vue';
import { getFeaturesByIds } from '../../router/features';

import webImage from '@/images/screenshots/web/theme-1-registration-full.png';
import CmsLarge from '@/components/Layouts/CmsLarge.vue';

import appImage from '@/images/screenshots/app/theme-1/registration.png';

import builder from '@/images/screenshots/cms/registration-builder.png';

const tips = [
    'Use Contact Lists to segment your attendees and send targeted emails and communications to drive registrations.',
    'Use registration forms in Kiosks and directly within the Event App for a seemless signup experience with public access.',
    'Create multiple forms for different attendee types if your conditional logic is starting to get too complex.'
];

const baseFeature = getFeaturesByIds(['registrationandtickets'])[0];
const integrations = getFeaturesByIds(['badgesandkiosks', 'leadcapture', 'eventapp']);
</script>
